import React, { useEffect, useMemo, useRef, useState } from "react";
import {
  CircularProgress,
  Grid,
  Box,
  Card,
  Typography,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  DialogContentText,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  useTheme,
  useMediaQuery,
  MenuItem,
  Select,
  IconButton,
  Tooltip,
  Checkbox,
  ListItem,
  List,
} from "@mui/material";
import {
  useGetEmployeePayRollAdminQuery,
  useGetPositionQuery,
  useGetlastUpdateDatePayrollQuery,
  useGetAnEmployeePayRollAdminQuery,
  useGetEmployeePayRollAdminUseMutation,
  useGetDayRecordAnEmplEachRecordQuery,
} from "../../../Api/attoDeskApi";
import {
  IApiResponse,
  IEmployeePayroll,
  IPayrollSummaryList,
  IPosition,
  IEmployeePunchRecord,
  IBonusAdjustments,
  IPayrollEachEmployeDateList,
} from "../../../Api/Interface/api.interface";
import { useStyles } from "../../../theme/appStyles";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs, { Dayjs } from "dayjs";
import TableViewIcon from "@mui/icons-material/TableView";
import CloseIcon from "@mui/icons-material/Close";
import { useNotifier } from "../../../Core/Notifier";
import useDebounce from "../../../Components/SearchDebonce/useDebounce";
import { useNavigate } from "react-router-dom";
import { Privileges } from "../../../Core/Enum/enum";
import useUser from "../../../Core/hook/useUser";
import EditSharpIcon from "@mui/icons-material/EditSharp";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import VisibilitySharpIcon from "@mui/icons-material/VisibilitySharp";
import { useFormik } from "formik";
import { FaTrash } from "react-icons/fa";
import AddIcon from "@mui/icons-material/Add";
import PopupMessage from "./popup";
import LocalPrintshopSharpIcon from "@mui/icons-material/LocalPrintshopSharp";
import "jspdf-autotable";
import jsPDF from "jspdf";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import * as XLSX from "xlsx";
import useIsMobile from "../../../Core/hook/useIsMobile";
import { useSelector } from "react-redux";
import { RootState } from "../../../Store";

const formatTime = (time: string | undefined) => {
  if (!time) return "";
  const [hour, minute] = time.split(":").map(Number);
  const date = new Date();
  date.setHours(hour, minute);
  return new Intl.DateTimeFormat("en-CA", {
    hour: "numeric",
    minute: "numeric",
    hour12: true,
  }).format(date);
};

const generateWorkOrderNumber = (workOrderId: number) => {
  const date = new Date();
  const year = date.getFullYear().toString().slice(2);
  const month = (date.getMonth() + 1).toString().padStart(2, "0");
  const day = date.getDate().toString().padStart(2, "0");
  return `PR${year}${month}${day}-${workOrderId.toString().padStart(2, "0")}`;
};

const Index: React.FC = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const theme = useTheme();
  const { companyLogo, logowidthPrint, companyName } = useSelector(
    (state: RootState) => state.company
  );
  const isMobileRes = useIsMobile();
  const { showErrorMessage, showMessage } = useNotifier();
  const [searchQuery, setSearchQuery] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10000);
  const debouncedSearchQuery = useDebounce(searchQuery, 300);
  const componentRef = useRef<HTMLDivElement>(null);
  const { userHasRight } = useUser();
  const [payrollList, setPayrollList] = useState<IEmployeePayroll[]>([]);
  const [open, setOpen] = useState(false);
  const [editData, setEditData] = useState<IEmployeePayroll | null>(null);
  const [isEditDialogOpen, setIsEditDialogOpen] = useState(false);
  const [selectedEmpId, setSelectedEmpId] = useState<string | undefined>("");
  const [selectedName, setSelectedName] = useState<string | undefined>("");
  const [selectedHrs, setSelectedHrs] = useState<string | undefined>("0.00");
  const [selectedRecordDate, setSelectedRecordDate] = useState<
    string | undefined
  >("");
  const [coursingToDelete, setCoursingToDelete] =
    useState<IEmployeePayroll | null>(null);

  const {
    data: payrollLastupdateDateData,
    isLoading: payrollLastupdateDateLoading,
  } = useGetlastUpdateDatePayrollQuery();

  const payrollLastupdateDateList = useMemo(() => {
    return Array.isArray(payrollLastupdateDateData?.data)
      ? payrollLastupdateDateData?.data
      : [];
  }, [payrollLastupdateDateData?.data]);

  const lastDatePayroll =
    payrollLastupdateDateList?.length &&
    payrollLastupdateDateList[0].LastUpdateDate
      ? payrollLastupdateDateList[0].LastUpdateDate
      : null;

  const lastDatePayrollId =
    payrollLastupdateDateList?.length && payrollLastupdateDateList[0].id
      ? payrollLastupdateDateList[0].id
      : null;

  useEffect(() => {
    if (lastDatePayroll) {
      const formattedDate = dayjs(lastDatePayroll);
      setSelectedStartDate(formattedDate);
    }
  }, [lastDatePayroll]);

  const [selectedStartDate, setSelectedStartDate] = useState<Dayjs | undefined>(
    undefined
  );
  const [selectedEndDate, setSelectedEndDate] = useState<Dayjs | undefined>(
    undefined
  );
  const [openDialog, setOpenDialog] = useState<boolean>(false);
  const [openOnConfirm, setOnConfirm] = useState<boolean>(false);
  const [openAdminConfim, setOpenAdminConfim] = useState<boolean>(false);
  const [openAdminConfim2, setOpenAdminConfim2] = useState<boolean>(false);

  const [fieldSums, setFieldSums] = useState({
    hourly_salary: "0.00",
    ot_hourly_salary: "0.00",
    total_ot_hours: "0.00",
    total_normal_hours: "0.00",
    total_hours: "0.00",
    gross_salary: "0.00",
    ot_salary: "0.00",
    total_salary: "0.00",
    bonus_amount: "0.00",
  });

  const handleDialogConfirm = (confirmed: boolean) => {
    if (confirmed) {
      setOnConfirm(true);
    }
    setOpenDialog(false);
  };

  const { data, isLoading, isError, refetch } = useGetEmployeePayRollAdminQuery(
    selectedStartDate && selectedEndDate && openOnConfirm
      ? {
          startDate: selectedStartDate.format("YYYY-MM-DD"),
          endDate: selectedEndDate.format("YYYY-MM-DD"),
        }
      : { startDate: "", endDate: "" },
    { skip: !selectedStartDate || !selectedEndDate || !openOnConfirm }
  );

  const { data: positionData, isLoading: positionLoading } =
    useGetPositionQuery({
      searchText: "",
    });

  const {
    data: payRollEachEmployeeData,
    isLoading: payRollEachEmployeeLoading,
    error: payRollEachEmployeeIsError,
  } = useGetDayRecordAnEmplEachRecordQuery(
    selectedEmpId && selectedRecordDate
      ? {
          empid: selectedEmpId,
          recordDate: String(selectedRecordDate),
        }
      : { empid: "", recordDate: "" },
    { skip: !selectedEmpId || !selectedRecordDate }
  );

  const {
    data: payRollAnEmployeeData,
    isLoading: payRollAnEmployeeLoading,
    error: payRollAnEmployeeIsError,
  } = useGetAnEmployeePayRollAdminQuery(
    selectedEmpId && selectedStartDate && selectedEndDate
      ? {
          empid: selectedEmpId,
          startDate: selectedStartDate.format("YYYY-MM-DD"),
          endDate: selectedEndDate.format("YYYY-MM-DD"),
        }
      : { empid: "", startDate: "", endDate: "" },
    { skip: !selectedEmpId || !selectedStartDate || !selectedEndDate }
  );

  const [
    newEmployeeData,
    { isLoading: newEmployeeDataIsLoading, isError: newEmployeeDataIsError },
  ] = useGetEmployeePayRollAdminUseMutation();

  useEffect(() => {
    if (data) {
      setOnConfirm(false);
    }
  }, [data]);

  const handleStartDateChange = (newDate: Dayjs | null) => {
    setSelectedStartDate(newDate ?? undefined);
  };

  const handleEndDateChange = (newDate: Dayjs | null) => {
    setSelectedEndDate(newDate ?? undefined);
  };

  const positionList = useMemo(() => {
    return positionData?.data as IPosition[];
  }, [positionData?.data]);

  const payrollSummaryDataList = useMemo(() => {
    return data?.summary as IPayrollSummaryList;
  }, [data?.summary]);

  const updatePayrollDataList = useMemo(() => {
    return Array.isArray(data?.payrollData) ? data?.payrollData : [];
  }, [data?.payrollData]);

  const updateLastDatePayrollId =
    updatePayrollDataList?.length && updatePayrollDataList[0].id
      ? updatePayrollDataList[0].id
      : null;

  const payrollMessageList = data?.message;
  const postionMap = useMemo(() => {
    const map = new Map();
    positionList?.forEach((category) => {
      map.set(category.id, category.positionName);
    });
    return map;
  }, [positionList]);

  const EmpEachPunchRecord: IPayrollEachEmployeDateList[] = Array.isArray(
    payRollEachEmployeeData?.data
  )
    ? (payRollEachEmployeeData?.data as IPayrollEachEmployeDateList[])
    : [];

  const isGenerateEnabled =
    selectedStartDate &&
    selectedEndDate &&
    selectedStartDate.isBefore(selectedEndDate);

  const goToPreviousDay = () => {
    const prevDay =
      selectedStartDate?.subtract(1, "day") || dayjs().subtract(1, "day");
    handleStartDateChange(prevDay);
  };

  const goToNextDay = () => {
    const nextDay = selectedStartDate?.add(1, "day") || dayjs().add(1, "day");
    handleStartDateChange(nextDay);
  };

  const goToPreviousDayEnd = () => {
    const prevDay =
      selectedEndDate?.subtract(1, "day") || dayjs().subtract(1, "day");
    handleEndDateChange(prevDay);
  };

  const goToNextDayEnd = () => {
    const nextDay = selectedEndDate?.add(1, "day") || dayjs().add(1, "day");
    handleEndDateChange(nextDay);
  };

  const handleGeneratePayroll = () => {
    setOpenDialog(true);
  };

  // const handleDialogConfirm = (confirmed: boolean) => {
  //   setOnConfirm(true);
  //   setOpenDialog(false);
  // };

  const handleDialogClose = (confirmed: boolean) => {
    setOnConfirm(false);
    setOpenDialog(false);
  };

  const handleDialogCloseAdminConform = (confirmed: boolean) => {
    setOpenAdminConfim(false);
  };

  const handleDialogCloseAdminConform2 = (confirmed: boolean) => {
    setOpenAdminConfim2(false);
  };

  const handleGeneratePayrollAdminConform = () => {
    setOpenAdminConfim(true);
  };

  const handleDialogAdminConform = (confirmed: boolean) => {
    formik.handleSubmit();
  };

  const coursings: IEmployeePayroll[] = Array.isArray(data?.data)
    ? (data?.data as IEmployeePayroll[])
    : [];

  useEffect(() => {
    setPayrollList(coursings);
  }, [data]);

  useEffect(() => {
    setOnConfirm(false);
  }, [payrollLastupdateDateData]);

  useEffect(() => {
    if (selectedStartDate) {
      setSelectedEndDate(selectedStartDate.add(13, "day"));
    } else {
      setSelectedEndDate(undefined);
    }
  }, [selectedStartDate]);

  const handleEditOpen = (row: IEmployeePayroll) => {
    setEditData(row);
    setIsEditDialogOpen(true);
  };

  const handleEditClose = () => {
    setEditData(null);
    setIsEditDialogOpen(false);
  };

  const handleEditSave = () => {
    if (editData) {
      setPayrollList((prev) =>
        prev.map((item) =>
          item.employee_id === editData.employee_id
            ? { ...item, ...editData }
            : item
        )
      );
      handleEditClose();
    }
  };

  const handleAdjustmentChange = (
    index: number,
    field: keyof IBonusAdjustments,
    value: string | number
  ) => {
    if (editData) {
      const adjustments = [...editData.bonus_adjustments];
      adjustments[index] = { ...adjustments[index], [field]: value };
      handleEditChange("bonus_adjustments", adjustments);
    }
  };

  const addAdjustment = () => {
    if (editData) {
      const newAdjustment: IBonusAdjustments = {
        selector: "add",
        value: 0,
        remark: "",
      };
      handleEditChange("bonus_adjustments", [
        ...(editData.bonus_adjustments || []),
        newAdjustment,
      ]);
    }
  };

  const removeAdjustment = (index: number) => {
    if (editData) {
      const adjustments = [...editData.bonus_adjustments];
      adjustments.splice(index, 1);
      handleEditChange("bonus_adjustments", adjustments);
    }
  };

  useEffect(() => {
    if (editData && !editData.bonus_adjustments) {
      handleEditChange("bonus_adjustments", []);
    }
  }, [editData]);

  useEffect(() => {
    if (payrollList.length > 0) {
      setFieldSums(calculateSums(payrollList));
    }
  }, [payrollList]);

  const handleEditChange = (
    field: keyof IEmployeePayroll,
    value: string | number | IBonusAdjustments[]
  ) => {
    if (editData) {
      let updatedData = { ...editData, [field]: value };

      if (field !== "bonus_adjustments") {
        const totalNormalHours = parseFloat(
          String(updatedData.total_normal_hours || 0)
        );
        const hourlySalary = parseFloat(String(updatedData.hourly_salary || 0));
        const totalOtHours = parseFloat(
          String(updatedData.total_ot_hours || 0)
        );
        const otHourlySalary = parseFloat(
          String(updatedData.ot_hourly_salary || 0)
        );

        const bonusAmount = parseFloat(String(updatedData.bonus_amount || 0));

        const totalSalary =
          totalNormalHours * hourlySalary +
          totalOtHours * otHourlySalary +
          bonusAmount;

        const grossSalary = totalNormalHours * hourlySalary;

        const otSalary = totalOtHours * otHourlySalary;

        const totalHours = totalOtHours + totalNormalHours;

        updatedData.total_salary = totalSalary;
        updatedData.gross_salary = grossSalary;
        updatedData.ot_salary = otSalary;
        updatedData.total_hours = totalHours;
      }

      if (field === "bonus_adjustments" && Array.isArray(value)) {
        const adjustmentSalary = value.reduce((sum, adjustment) => {
          const amount = adjustment.value || 0;
          const actionType = adjustment.selector;
          return sum + (actionType === "add" ? amount : -amount);
        }, 0);

        updatedData.bonus_amount = adjustmentSalary;

        const totalNormalHours = parseFloat(
          String(updatedData.total_normal_hours || 0)
        );
        const hourlySalary = parseFloat(String(updatedData.hourly_salary || 0));
        const totalOtHours = parseFloat(
          String(updatedData.total_ot_hours || 0)
        );
        const otHourlySalary = parseFloat(
          String(updatedData.ot_hourly_salary || 0)
        );

        updatedData.total_salary =
          totalNormalHours * hourlySalary +
          totalOtHours * otHourlySalary +
          adjustmentSalary;
      }

      updatedData.is_Edited = true;

      setEditData(updatedData);
    }
  };

  const EmployeePunchRecord: IEmployeePunchRecord[] = Array.isArray(
    payRollAnEmployeeData?.data
  )
    ? (payRollAnEmployeeData?.data as IEmployeePunchRecord[])
    : [];

  const handleViewClick = (
    empid: string,
    employee_name: string,
    hourly_salary: string,
    coursing: IEmployeePayroll
  ) => {
    setSelectedEmpId(empid);
    setSelectedName(employee_name);
    setSelectedHrs(hourly_salary);
    setCoursingToDelete(coursing);
    setOpen(true);
  };

  const handleDateViewClick = (recordDate: string) => {
    setSelectedRecordDate(recordDate);
    setOpenAdminConfim2(true);
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedEmpId(undefined);
    setSelectedName(undefined);
    setSelectedHrs(undefined);
    setCoursingToDelete(null);
  };

  const handleCheckboxChange = (index: number) => {
    setPayrollList((prevData) =>
      prevData.map((row, i) =>
        i === index
          ? {
              ...row,
              isConformToGeneratePayroll: !row.isConformToGeneratePayroll,
            }
          : row
      )
    );
  };

  const formik = useFormik({
    initialValues: {
      payrollList: [],
      payrollListDashboard: [],
      startDate: "",
      endDate: "",
      payrollId: "",
      description: "",
      payrollGenerateId: "",
    },
    onSubmit: async (values, { resetForm }) => {
      try {
        const temData = {
          payrollList: payrollList,
          total_ot_hours: fieldSums.total_ot_hours,
          total_normal_hours: fieldSums.total_normal_hours,
          total_hours: fieldSums.total_hours,
          gross_salary: fieldSums.gross_salary,
          ot_salary: fieldSums.ot_salary,
          total_salary: fieldSums.total_salary,
          bonus_amount: fieldSums.bonus_amount,
          startDate: selectedStartDate
            ? selectedStartDate.format("YYYY-MM-DD")
            : "",
          endDate: selectedEndDate ? selectedEndDate.format("YYYY-MM-DD") : "",
          payrollId: updateLastDatePayrollId,
          payrollGenerateId: values.payrollGenerateId,
          description: values.description,
        };

        const addCompanyResponse = await newEmployeeData(temData).unwrap();
        if (!addCompanyResponse.status) {
          showErrorMessage(addCompanyResponse.message);
        } else {
          showMessage(addCompanyResponse.message);
          setOpenAdminConfim(false);
          // navigate("/payroll/list");
          navigate(`/payroll/list/${updateLastDatePayrollId}`);
        }
      } catch (error) {
        showErrorMessage("Something went wrong");
      }
    },
  });

  useEffect(() => {
    if (updateLastDatePayrollId !== null) {
      const payrollGenerateId = generateWorkOrderNumber(
        updateLastDatePayrollId
      );
      formik.setFieldValue("payrollGenerateId", payrollGenerateId);
    }
  }, [updateLastDatePayrollId]);

  const calculateSums = (data: IEmployeePayroll[]) => {
    const initialSums = {
      hourly_salary: 0,
      ot_hourly_salary: 0,
      total_ot_hours: 0,
      total_normal_hours: 0,
      total_hours: 0,
      gross_salary: 0,
      ot_salary: 0,
      total_salary: 0,
      bonus_amount: 0,
    };

    // const sums = data.reduce((acc, row) => {
    //   acc.hourly_salary += parseFloat(row.hourly_salary) || 0;
    //   acc.ot_hourly_salary += parseFloat(row.ot_hourly_salary) || 0;
    //   acc.total_ot_hours += row.total_ot_hours || 0;
    //   acc.total_normal_hours += row.total_normal_hours || 0;
    //   acc.total_hours += row.total_hours || 0;
    //   acc.gross_salary += row.gross_salary || 0;
    //   acc.ot_salary += row.ot_salary || 0;
    //   acc.total_salary += row.total_salary || 0;
    //   acc.bonus_amount += row.bonus_amount || 0;
    //   return acc;
    // }, initialSums);

    const sums = data.reduce((acc, row) => {
      if (row.isConformToGeneratePayroll) {
        acc.hourly_salary += parseFloat(row.hourly_salary as any) || 0;
        acc.ot_hourly_salary += parseFloat(row.ot_hourly_salary as any) || 0;
        acc.total_ot_hours += row.total_ot_hours || 0;
        acc.total_normal_hours += row.total_normal_hours || 0;
        acc.total_hours += row.total_hours || 0;
        acc.gross_salary += row.gross_salary || 0;
        acc.ot_salary += row.ot_salary || 0;
        acc.total_salary += row.total_salary || 0;
        acc.bonus_amount += row.bonus_amount || 0;
      }
      return acc;
    }, initialSums);

    return {
      hourly_salary: sums.hourly_salary.toFixed(2),
      ot_hourly_salary: sums.ot_hourly_salary.toFixed(2),
      total_ot_hours: sums.total_ot_hours.toFixed(2),
      total_normal_hours: sums.total_normal_hours.toFixed(2),
      total_hours: sums.total_hours.toFixed(2),
      gross_salary: sums.gross_salary.toFixed(2),
      ot_salary: sums.ot_salary.toFixed(2),
      total_salary: sums.total_salary.toFixed(2),
      bonus_amount: sums.bonus_amount.toFixed(2),
    };
  };

  const handleExportToPDFForEmployeePunch = () => {
    const tableData = EmployeePunchRecord.map((row, index) => [
      dayjs(row.recordDate).format("YYYY-MM-DD"),
      row.punchDetails.length > 0
        ? row.punchDetails
            .map(
              (punchDetail) =>
                `${formatTime(punchDetail.punch_in_time)} - ${formatTime(
                  punchDetail.punch_out_time
                )}`
            )
            .join(", ")
        : "",
      row.break_hours === null ||
      row.total_hours === null ||
      isNaN(parseFloat(String(row.break_hours))) ||
      isNaN(parseFloat(String(row.total_hours)))
        ? ""
        : parseFloat(String(row.break_hours)) +
            parseFloat(String(row.total_hours)) ===
          0
        ? "-"
        : `${(
            parseFloat(String(row.break_hours)) +
            parseFloat(String(row.total_hours))
          ).toFixed(2)} hrs`,
      row.break_hours === null || isNaN(parseFloat(String(row.break_hours)))
        ? ""
        : parseFloat(String(row.break_hours)) === 0
        ? "-"
        : `${parseFloat(String(row.break_hours)).toFixed(2)} hrs`,
      row.total_hours === null || isNaN(parseFloat(String(row.total_hours)))
        ? ""
        : parseFloat(String(row.total_hours)) === 0
        ? "-"
        : `${parseFloat(String(row.total_hours)).toFixed(2)} hrs`,
      selectedHrs === null || isNaN(parseFloat(String(selectedHrs)))
        ? ""
        : parseFloat(String(selectedHrs)) === 0
        ? "-"
        : `$ ${parseFloat(String(selectedHrs)).toFixed(2)}`,
      selectedHrs === null ||
      row.total_hours === null ||
      isNaN(parseFloat(String(selectedHrs)) * row.total_hours)
        ? ""
        : parseFloat(String(selectedHrs)) * row.total_hours === 0
        ? "-"
        : `$ ${(parseFloat(String(selectedHrs)) * row.total_hours).toFixed(2)}`,
    ]);

    tableData.push([
      "",
      "",
      "",
      coursingToDelete &&
      coursingToDelete.total_break_hours !== null &&
      !isNaN(parseFloat(String(coursingToDelete.total_break_hours)))
        ? parseFloat(String(coursingToDelete.total_break_hours)) === 0
          ? "-"
          : `${parseFloat(String(coursingToDelete.total_break_hours)).toFixed(
              2
            )} hrs`
        : "",
      coursingToDelete &&
      coursingToDelete.total_hours !== null &&
      !isNaN(parseFloat(String(coursingToDelete.total_hours)))
        ? parseFloat(String(coursingToDelete.total_hours)) === 0
          ? "-"
          : `${parseFloat(String(coursingToDelete.total_hours)).toFixed(2)} hrs`
        : "",
      "",
      coursingToDelete &&
      coursingToDelete.gross_salary !== null &&
      !isNaN(parseFloat(String(coursingToDelete.gross_salary)))
        ? parseFloat(String(coursingToDelete.gross_salary)) === 0
          ? "-"
          : `$ ${parseFloat(String(coursingToDelete.gross_salary)).toFixed(2)}`
        : "",
    ]);

    const tableHeaders = [
      [
        "Date",
        "Records",
        "Actual Hours",
        "Total Break Hours",
        "Total working hours",
        "Hourly Salary",
        "Total Amount",
      ],
    ];

    const currentMonth = dayjs().format("YYYY MMM, DD");

    const doc = new jsPDF("l", "mm", "a4");

    const imageUrl = companyLogo;
    const pageWidth = doc.internal.pageSize.width;
    const imgWidth = logowidthPrint;
    const imgHeight = 10;
    // const imgX = (pageWidth - imgWidth) / 2;
    const imgY = 10;
    const imgX = 15;

    const img = new Image();
    img.src = imageUrl;

    img.onload = () => {
      doc.addImage(img, "PNG", imgX, imgY, imgWidth, imgHeight);

      const textStartY = imgY + imgHeight / 2;

      const centerText = (text: string, y: number) => {
        const textWidth = doc.getTextWidth(text);
        const textX = (pageWidth - textWidth) / 2;
        doc.text(text, textX, y);
      };

      const rightAlignText = (text: string, y: number) => {
        doc.setFontSize(10);
        const textWidth = doc.getTextWidth(text);
        const textX = pageWidth - textWidth - 15;
        doc.text(text, textX, y);
      };

      doc.setFontSize(10);
      doc.setFont("helvetica", "normal");
      rightAlignText(`Payroll Summary - ${selectedName}`, textStartY);

      doc.setFontSize(10);
      doc.setFont("helvetica", "normal");
      rightAlignText(
        `Period: ${selectedStartDate?.format("MMM-DD, YYYY") || " "} to ${
          selectedEndDate?.format("MMM-DD, YYYY") || " "
        }`,
        textStartY + 5
      );

      (doc as any).autoTable({
        head: tableHeaders,
        body: tableData,
        startY: textStartY + 15,
        theme: "grid",
        styles: { fontSize: 8 },
        headStyles: { fillColor: [200, 200, 200] },
        alternateRowStyles: { fillColor: [245, 245, 245] },
      });

      const fileName = `PayrollSummary_${
        selectedStartDate?.format("MMM-DD, YYYY") || " "
      }_to_${
        selectedEndDate?.format("MMM-DD, YYYY") || " "
      }_${selectedName}.pdf`;

      doc.save(fileName);
    };
  };

  const handleEmployeePunchExcel = () => {
    const tableData = EmployeePunchRecord.map((row, index) => [
      dayjs(row.recordDate).format("YYYY-MM-DD"),
      // row.punchDetails.length > 0
      //   ? row.punchDetails
      //       .map(
      //         (punchDetail) =>
      //           `${formatTime(punchDetail.punch_in_time)} - ${formatTime(
      //             punchDetail.punch_out_time
      //           )}`
      //       )
      //       .join(", ")
      //   : "",
      row.punchDetails.length > 0
        ? row.punchDetails
            .map((punchDetail) => {
              const inTime = formatTime(punchDetail.punch_in_time);
              const outTime = punchDetail.punch_out_time
                ? punchDetail.punch_in_date !== punchDetail.punch_out_date
                  ? `${dayjs(punchDetail.punch_out_date).format(
                      "MMM-DD, YYYY"
                    )} ${formatTime(punchDetail.punch_out_time)}`
                  : formatTime(punchDetail.punch_out_time)
                : "Pending";

              return `${inTime} - ${outTime}`;
            })
            .join(", ")
        : "",
      row.break_hours === null ||
      row.total_hours === null ||
      isNaN(parseFloat(String(row.break_hours))) ||
      isNaN(parseFloat(String(row.total_hours)))
        ? ""
        : parseFloat(String(row.break_hours)) +
            parseFloat(String(row.total_hours)) ===
          0
        ? "-"
        : `${(
            parseFloat(String(row.break_hours)) +
            parseFloat(String(row.total_hours))
          ).toFixed(2)} hrs`,
      row.break_hours === null || isNaN(parseFloat(String(row.break_hours)))
        ? ""
        : parseFloat(String(row.break_hours)) === 0
        ? "-"
        : `${parseFloat(String(row.break_hours)).toFixed(2)} hrs`,
      row.total_hours === null || isNaN(parseFloat(String(row.total_hours)))
        ? ""
        : parseFloat(String(row.total_hours)) === 0
        ? "-"
        : `${parseFloat(String(row.total_hours)).toFixed(2)} hrs`,
      selectedHrs === null || isNaN(parseFloat(String(selectedHrs)))
        ? ""
        : parseFloat(String(selectedHrs)) === 0
        ? "-"
        : `$ ${parseFloat(String(selectedHrs)).toFixed(2)}`,
      selectedHrs === null ||
      row.total_hours === null ||
      isNaN(parseFloat(String(selectedHrs)) * row.total_hours)
        ? ""
        : parseFloat(String(selectedHrs)) * row.total_hours === 0
        ? "-"
        : `$ ${(parseFloat(String(selectedHrs)) * row.total_hours).toFixed(2)}`,
    ]);

    tableData.push([
      "",
      "",
      "",
      coursingToDelete &&
      coursingToDelete.total_break_hours !== null &&
      !isNaN(parseFloat(String(coursingToDelete.total_break_hours)))
        ? parseFloat(String(coursingToDelete.total_break_hours)) === 0
          ? "-"
          : `${parseFloat(String(coursingToDelete.total_break_hours)).toFixed(
              2
            )} hrs`
        : "",
      coursingToDelete &&
      coursingToDelete.total_hours !== null &&
      !isNaN(parseFloat(String(coursingToDelete.total_hours)))
        ? parseFloat(String(coursingToDelete.total_hours)) === 0
          ? "-"
          : `${parseFloat(String(coursingToDelete.total_hours)).toFixed(2)} hrs`
        : "",
      "",
      coursingToDelete &&
      coursingToDelete.gross_salary !== null &&
      !isNaN(parseFloat(String(coursingToDelete.gross_salary)))
        ? parseFloat(String(coursingToDelete.gross_salary)) === 0
          ? "-"
          : `$ ${parseFloat(String(coursingToDelete.gross_salary)).toFixed(2)}`
        : "",
    ]);

    const tableHeaders = [
      [
        "Date",
        "Records",
        "Actual Hours",
        "Total Break Hours",
        "Total working hours",
        "Hourly Salary",
        "Total Amount",
      ],
    ];

    const worksheet = XLSX.utils.aoa_to_sheet([tableHeaders[0], ...tableData]);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "PayrollSummary");

    const fileName = `PayrollSummary_${
      selectedStartDate?.format("MMM-DD-YYYY") || " "
    }_to_${selectedEndDate?.format("MMM-DD-YYYY") || " "}_${selectedName}.xlsx`;
    XLSX.writeFile(workbook, fileName);
  };

  const allSelected =
    payrollList.length > 0 &&
    payrollList.every((item) => item.isConformToGeneratePayroll);

  const handleSelectAll = () => {
    const newValue = !allSelected;
    setPayrollList((prevList) =>
      prevList.map((item) => ({
        ...item,
        isConformToGeneratePayroll: newValue,
      }))
    );
  };

  return (
    <div>
      <Card className={classes.quotesCard}>
        <Grid container spacing={3} padding={isMobileRes ? "1px" : 2}>
          <Grid
            item
            lg={12}
            md={12}
            sm={12}
            xs={12}
            sx={{ paddingBottom: 5 }}
            className={classes.titleGrid}
          >
            <Grid
              container
              style={{
                display: "flex",
                flexDirection: "column",
              }}
              className={classes.backgroundColorView2}
            >
              <Grid item lg={12} md={12} sm={12} xs={12} pt={2}>
                <Grid container spacing={3} padding={2}>
                  <Grid
                    item
                    lg={12}
                    md={12}
                    sm={12}
                    xs={12}
                    className={classes.titleGrid}
                  >
                    <Grid container spacing={5}>
                      <Grid item lg={12} md={12} sm={12} xs={12}>
                        <Grid container alignItems="start" spacing={2}>
                          <Grid item lg={1} md={2} sm={12} xs={12}>
                            <Typography className={classes.cardTitle256}>
                              Start Date
                            </Typography>
                          </Grid>
                          <Grid item>
                            <List className={classes.ListPayroll}>
                              <ListItem className={classes.ListItemPayroll}>
                                <IconButton
                                  color="primary"
                                  onClick={goToPreviousDay}
                                  aria-label="Previous Day"
                                >
                                  <KeyboardArrowLeftIcon />
                                </IconButton>
                              </ListItem>
                              <ListItem className={classes.ListItemPayroll}>
                                <Button
                                  className={classes.ListItemPayrollToday}
                                  // onClick={goToToday}
                                  // aria-label="Today"
                                >
                                  <LocalizationProvider
                                    dateAdapter={AdapterDayjs}
                                  >
                                    <DatePicker
                                      value={selectedStartDate}
                                      onChange={handleStartDateChange}
                                      slotProps={{
                                        textField: {
                                          placeholder: "Start Date",
                                          size: "small",
                                          sx: {
                                            width: "140px",
                                          },
                                          InputProps: {
                                            sx: {
                                              fontSize: 14,
                                              color: "#97c3df",
                                            },
                                            // classes: {
                                            //   // root: classes.textFieldQuote,
                                            // },
                                            classes: {
                                              root: classes.formControlListStatus,
                                              notchedOutline:
                                                classes.notchedOutline,
                                            },
                                          },
                                          InputLabelProps: {
                                            sx: {
                                              fontSize: 14,
                                              color: "#97c3df",
                                            },
                                          },
                                        },
                                      }}
                                    />
                                  </LocalizationProvider>
                                </Button>
                              </ListItem>
                              <ListItem className={classes.ListItemPayroll}>
                                <IconButton
                                  color="primary"
                                  onClick={goToNextDay}
                                  aria-label="Previous Day"
                                >
                                  <KeyboardArrowRightIcon />
                                </IconButton>
                              </ListItem>
                            </List>
                          </Grid>
                          {/* <Grid item lg={6} md={6} sm={4} xs={4}>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                              <DatePicker
                                value={selectedStartDate}
                                onChange={handleStartDateChange}
                                className={classes.searchTextField}
                                // disabled
                                slotProps={{
                                  textField: {
                                    placeholder: "Start Date",
                                    size: "small",
                                    sx: {
                                      width: "200px",
                                    },
                                    InputProps: {
                                      sx: {
                                        fontSize: 14,
                                      },
                                      classes: {
                                        root: classes.formControlListStatus,
                                      },
                                    },
                                    InputLabelProps: {
                                      sx: {
                                        fontSize: 14,
                                      },
                                    },
                                  },
                                }}
                              />
                            </LocalizationProvider>
                          </Grid> */}
                        </Grid>
                      </Grid>
                      <Grid item lg={12} md={12} sm={12} xs={12}>
                        <Grid container alignItems="start" spacing={2}>
                          <Grid item lg={1} md={2} sm={12} xs={12}>
                            <Typography className={classes.cardTitle256}>
                              End Date
                            </Typography>
                          </Grid>
                          <Grid item>
                            <List className={classes.ListPayroll}>
                              <ListItem className={classes.ListItemPayroll}>
                                <IconButton
                                  color="primary"
                                  onClick={goToPreviousDayEnd}
                                  aria-label="Previous Day"
                                >
                                  <KeyboardArrowLeftIcon />
                                </IconButton>
                              </ListItem>
                              <ListItem className={classes.ListItemPayroll}>
                                <Button
                                  className={classes.ListItemPayrollToday}
                                  // onClick={goToToday}
                                  // aria-label="Today"
                                >
                                  <LocalizationProvider
                                    dateAdapter={AdapterDayjs}
                                  >
                                    <DatePicker
                                      value={selectedEndDate}
                                      onChange={handleEndDateChange}
                                      slotProps={{
                                        textField: {
                                          placeholder: "End Date",
                                          size: "small",
                                          sx: {
                                            width: "140px",
                                          },
                                          InputProps: {
                                            sx: {
                                              fontSize: 14,
                                              color: "#97c3df",
                                            },
                                            // classes: {
                                            //   // root: classes.textFieldQuote,
                                            // },
                                            classes: {
                                              root: classes.formControlListStatus,
                                              notchedOutline:
                                                classes.notchedOutline,
                                            },
                                          },
                                          InputLabelProps: {
                                            sx: {
                                              fontSize: 14,
                                              color: "#97c3df",
                                            },
                                          },
                                        },
                                      }}
                                    />
                                  </LocalizationProvider>
                                </Button>
                              </ListItem>
                              <ListItem className={classes.ListItemPayroll}>
                                <IconButton
                                  color="primary"
                                  onClick={goToNextDayEnd}
                                  aria-label="Previous Day"
                                >
                                  <KeyboardArrowRightIcon />
                                </IconButton>
                              </ListItem>
                            </List>
                          </Grid>
                          {/* <Grid item lg={2} md={2} sm={4} xs={4}>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                              <DatePicker
                                value={selectedEndDate}
                                onChange={handleEndDateChange}
                                className={classes.searchTextField}
                                disabled={coursings.length > 0}
                                // disabled
                                slotProps={{
                                  textField: {
                                    placeholder: "End Date",
                                    size: "small",
                                    sx: {
                                      width: "200px",
                                    },
                                    InputProps: {
                                      sx: {
                                        fontSize: 14,
                                      },
                                      classes: {
                                        root: classes.formControlListStatus,
                                      },
                                    },
                                    InputLabelProps: {
                                      sx: {
                                        fontSize: 14,
                                      },
                                    },
                                  },
                                }}
                              />
                            </LocalizationProvider>
                          </Grid> */}
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
              {userHasRight(Privileges.GeneratePayroll) && (
                <Grid
                  item
                  lg={12}
                  md={12}
                  sm={12}
                  xs={12}
                  sx={{
                    display: "flex",
                    justifyContent: "flex-end",
                  }}
                  pb={5}
                  pr={2}
                >
                  <Button
                    variant="contained"
                    startIcon={<TableViewIcon />}
                    className={classes.addButton}
                    disabled={!isGenerateEnabled || coursings.length > 0}
                    onClick={handleGeneratePayroll}
                  >
                    Generate Payroll
                  </Button>
                </Grid>
              )}
            </Grid>
          </Grid>
          {isLoading ? (
            <>
              <Grid
                item
                lg={12}
                md={12}
                sm={12}
                xs={12}
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  minHeight: "200px",
                }}
              >
                <CircularProgress />
              </Grid>
            </>
          ) : payrollMessageList ? (
            <Grid
              item
              lg={12}
              md={12}
              sm={12}
              xs={12}
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                minHeight: "200px",
              }}
            >
              <PopupMessage message={payrollMessageList} />
            </Grid>
          ) : data && coursings.length === 0 ? (
            <Grid
              item
              lg={12}
              md={12}
              sm={12}
              xs={12}
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                minHeight: "200px",
              }}
            >
              <Grid container spacing={2}>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <Typography className={classes.bodyDialog}>
                    No Clock In/Out records found for the selected date range.
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
          ) : coursings.length > 0 ? (
            <>
              <Grid
                item
                lg={12}
                md={12}
                sm={12}
                xs={12}
                sx={{ paddingBottom: 5 }}
                className={classes.titleGrid}
              >
                <Grid container spacing={2}>
                  <Grid
                    item
                    lg={12}
                    md={12}
                    sm={12}
                    xs={12}
                    className={classes.titleGrid}
                  >
                    <Grid
                      container
                      spacing={1}
                      justifyContent="flex-end"
                      sx={{ display: "flex" }}
                    >
                      <Grid item>
                        <Typography className={classes.cardTitle2}>
                          {formik.values.payrollGenerateId}
                        </Typography>
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item lg={12} md={12} sm={12} xs={12} pt={3}>
                    <div ref={componentRef}>
                      <TableContainer>
                        <Table className={classes.table}>
                          <TableHead className={classes.tableHeaderRow}>
                            <TableRow>
                              <TableCell className={classes.tablheaderId}>
                                <Checkbox
                                  checked={allSelected}
                                  indeterminate={
                                    !allSelected &&
                                    payrollList.some(
                                      (item) => item.isConformToGeneratePayroll
                                    )
                                  }
                                  onChange={handleSelectAll}
                                />
                              </TableCell>
                              <TableCell className={classes.tablheaderPayroll}>
                                <strong>Employee Name</strong>
                              </TableCell>
                              <TableCell className={classes.tablheaderPayroll}>
                                <strong>Position</strong>
                              </TableCell>
                              <TableCell
                                className={classes.tablheaderPayroll}
                                sx={{ textAlign: "right", width: "10%" }}
                              >
                                <strong>Normal Working Hours</strong>
                              </TableCell>
                              <TableCell
                                className={classes.tablheaderPayroll}
                                sx={{ textAlign: "right", width: "10%" }}
                              >
                                <strong>Wrk Hourly Salary</strong>
                              </TableCell>
                              <TableCell
                                className={classes.tablheaderPayroll}
                                sx={{ textAlign: "right", width: "10%" }}
                              >
                                <strong>OT Hours</strong>
                              </TableCell>
                              <TableCell
                                className={classes.tablheaderPayroll}
                                sx={{ textAlign: "right", width: "10%" }}
                              >
                                <strong>OT Hourly Salary</strong>
                              </TableCell>
                              <TableCell
                                className={classes.tablheaderPayroll}
                                sx={{ textAlign: "right", width: "10%" }}
                              >
                                <strong>Adjustment Amount</strong>
                              </TableCell>
                              <TableCell
                                className={classes.tablheaderPayroll}
                                sx={{ textAlign: "right", width: "10%" }}
                              >
                                <strong>Total Salary</strong>
                              </TableCell>
                              {userHasRight(Privileges.GeneratePayroll) && (
                                <TableCell
                                  className={classes.tablheaderPayroll}
                                  sx={{ textAlign: "right" }}
                                >
                                  <strong>Actions</strong>
                                </TableCell>
                              )}
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {isLoading || positionLoading ? (
                              <TableRow>
                                <TableCell colSpan={20} align="center">
                                  <Box
                                    display="flex"
                                    justifyContent="center"
                                    alignItems="center"
                                    height="10vh"
                                  >
                                    <CircularProgress />
                                  </Box>
                                </TableCell>
                              </TableRow>
                            ) : isError ? (
                              <TableRow>
                                <TableCell colSpan={20} align="center">
                                  Something went wrong
                                </TableCell>
                              </TableRow>
                            ) : coursings.length === 0 ? (
                              <TableRow>
                                <TableCell colSpan={20} align="center">
                                  {payrollMessageList ? (
                                    <PopupMessage
                                      message={payrollMessageList}
                                    />
                                  ) : (
                                    "No data available"
                                  )}
                                </TableCell>
                              </TableRow>
                            ) : (
                              payrollList.map(
                                (row: IEmployeePayroll, index) => (
                                  <TableRow
                                    key={index}
                                    className={classes.tableRowHover}
                                    // sx={{
                                    //   backgroundColor: row.isPreviousPaymentPaid
                                    //     ? "#f79aa61c"
                                    //     : "transparent",
                                    // }}
                                  >
                                    <TableCell
                                      scope="row"
                                      className={classes.tablCellId}
                                    >
                                      <Checkbox
                                        checked={row.isConformToGeneratePayroll}
                                        onChange={() =>
                                          handleCheckboxChange(index)
                                        }
                                      />
                                    </TableCell>
                                    <TableCell
                                      scope="row"
                                      className={classes.tablCellPayroll}
                                    >
                                      {row.employee_name}
                                    </TableCell>
                                    <TableCell
                                      scope="row"
                                      className={classes.tablCellPayroll}
                                    >
                                      {postionMap.get(
                                        row.employee_position_id
                                      ) || ""}
                                    </TableCell>
                                    <TableCell
                                      scope="row"
                                      className={classes.tablCellPayroll}
                                      sx={{ textAlign: "right" }}
                                    >
                                      {row.total_normal_hours === null ||
                                      isNaN(
                                        parseFloat(
                                          String(row.total_normal_hours)
                                        )
                                      )
                                        ? ""
                                        : parseFloat(
                                            String(row.total_normal_hours)
                                          ).toFixed(2)}
                                    </TableCell>
                                    <TableCell
                                      scope="row"
                                      className={classes.tablCellPayroll}
                                      sx={{ textAlign: "right" }}
                                    >
                                      {row.hourly_salary === null ||
                                      isNaN(
                                        parseFloat(String(row.hourly_salary))
                                      )
                                        ? ""
                                        : parseFloat(
                                            String(row.hourly_salary)
                                          ).toFixed(2)}
                                    </TableCell>
                                    <TableCell
                                      scope="row"
                                      className={classes.tablCellPayroll}
                                      sx={{ textAlign: "right" }}
                                    >
                                      {row.total_ot_hours === null ||
                                      isNaN(
                                        parseFloat(String(row.total_ot_hours))
                                      )
                                        ? ""
                                        : parseFloat(
                                            String(row.total_ot_hours)
                                          ) === 0
                                        ? "-"
                                        : parseFloat(
                                            String(row.total_ot_hours)
                                          ).toFixed(2)}
                                    </TableCell>
                                    <TableCell
                                      scope="row"
                                      className={classes.tablCellPayroll}
                                      sx={{ textAlign: "right" }}
                                    >
                                      {/* {row.ot_hourly_salary === null ||
                                isNaN(parseFloat(String(row.ot_hourly_salary)))
                                  ? ""
                                  : parseFloat(String(row.ot_hourly_salary)) ===
                                    0
                                  ? "-"
                                  : parseFloat(
                                      String(row.ot_hourly_salary)
                                    ).toFixed(2)} */}

                                      {row.total_ot_hours !== null &&
                                      !isNaN(
                                        parseFloat(String(row.total_ot_hours))
                                      ) &&
                                      parseFloat(String(row.total_ot_hours)) > 0
                                        ? row.ot_hourly_salary !== null &&
                                          !isNaN(
                                            parseFloat(
                                              String(row.ot_hourly_salary)
                                            )
                                          )
                                          ? parseFloat(
                                              String(row.ot_hourly_salary)
                                            ).toFixed(2)
                                          : "-"
                                        : "-"}
                                    </TableCell>
                                    <TableCell
                                      scope="row"
                                      className={classes.tablCellPayroll}
                                      sx={{ textAlign: "right" }}
                                    >
                                      {row.bonus_adjustments.length > 0 ? (
                                        <Tooltip
                                          title={
                                            <>
                                              {row.bonus_adjustments.map(
                                                (row, index) => (
                                                  <Typography
                                                    variant="body2"
                                                    key={index}
                                                  >
                                                    <strong>
                                                      {row.remark}
                                                    </strong>
                                                    {" : "}
                                                    {row.value}
                                                  </Typography>
                                                )
                                              )}
                                            </>
                                          }
                                          sx={{ fontSize: "14px" }}
                                        >
                                          <span
                                            style={{
                                              cursor:
                                                row.bonus_adjustments.length > 0
                                                  ? "pointer"
                                                  : "default",
                                            }}
                                          >
                                            {row.bonus_amount === null ||
                                            isNaN(
                                              parseFloat(
                                                String(row.bonus_amount)
                                              )
                                            )
                                              ? ""
                                              : parseFloat(
                                                  String(row.bonus_amount)
                                                ) === 0
                                              ? "-"
                                              : parseFloat(
                                                  String(row.bonus_amount)
                                                ).toFixed(2)}

                                            {/* {row.bonus_amount === null ||
                                      isNaN(
                                        parseFloat(String(row.bonus_amount))
                                      )
                                        ? ""
                                        : parseFloat(
                                            String(row.bonus_amount)
                                          ).toFixed(2)} */}
                                          </span>
                                        </Tooltip>
                                      ) : (
                                        <span>
                                          {row.bonus_amount === null ||
                                          isNaN(
                                            parseFloat(String(row.bonus_amount))
                                          )
                                            ? ""
                                            : parseFloat(
                                                String(row.bonus_amount)
                                              ) === 0
                                            ? "-"
                                            : parseFloat(
                                                String(row.bonus_amount)
                                              ).toFixed(2)}

                                          {/* {row.bonus_amount === null ||
                                    isNaN(parseFloat(String(row.bonus_amount)))
                                      ? ""
                                      : parseFloat(
                                          String(row.bonus_amount)
                                        ).toFixed(2)} */}
                                        </span>
                                      )}
                                    </TableCell>
                                    <TableCell
                                      scope="row"
                                      className={classes.tablCellPayroll}
                                      sx={{ textAlign: "right" }}
                                    >
                                      {row.total_salary === null ||
                                      isNaN(
                                        parseFloat(String(row.total_salary))
                                      )
                                        ? ""
                                        : parseFloat(
                                            String(row.total_salary)
                                          ).toFixed(2)}
                                    </TableCell>
                                    {userHasRight(
                                      Privileges.GeneratePayroll
                                    ) && (
                                      <TableCell
                                        className={classes.tablCellPayroll}
                                      >
                                        <Grid
                                          container
                                          spacing={1}
                                          sx={{
                                            display: "flex",
                                            justifyContent: "flex-end",
                                          }}
                                        >
                                          <Tooltip
                                            title={
                                              <>
                                                <Typography
                                                  variant="body2"
                                                  key={index}
                                                >
                                                  <strong>View All</strong>
                                                </Typography>
                                                <Typography
                                                  variant="body2"
                                                  key={index}
                                                >
                                                  <strong>
                                                    Punch Details Records
                                                  </strong>
                                                </Typography>
                                              </>
                                            }
                                            sx={{ fontSize: "14px" }}
                                          >
                                            <Grid item>
                                              <Button
                                                // variant="contained"
                                                className={
                                                  classes.viewButtonList
                                                }
                                                onClick={() =>
                                                  handleViewClick(
                                                    String(row.employee_id),
                                                    String(row.employee_name),
                                                    String(row.hourly_salary),
                                                    row
                                                  )
                                                }
                                              >
                                                <VisibilitySharpIcon
                                                  className={
                                                    classes.viewListIcon
                                                  }
                                                />
                                              </Button>
                                            </Grid>
                                          </Tooltip>
                                          <Tooltip
                                            title={
                                              row.isConformToGeneratePayroll ? (
                                                <>
                                                  <Typography
                                                    variant="body2"
                                                    key={index}
                                                  >
                                                    <strong>
                                                      Edit Adjustment Amount
                                                    </strong>
                                                  </Typography>
                                                  <Typography
                                                    variant="body2"
                                                    key={index}
                                                  >
                                                    <strong>
                                                      && Other Details
                                                    </strong>
                                                  </Typography>
                                                </>
                                              ) : (
                                                ""
                                              )
                                            }
                                            disableHoverListener={
                                              !row.isConformToGeneratePayroll
                                            }
                                            disableFocusListener={
                                              !row.isConformToGeneratePayroll
                                            }
                                            disableTouchListener={
                                              !row.isConformToGeneratePayroll
                                            }
                                            sx={{ fontSize: "14px" }}
                                          >
                                            <Grid item>
                                              <Button
                                                // variant="contained"
                                                className={
                                                  classes.editButtonList
                                                }
                                                onClick={() =>
                                                  handleEditOpen(row)
                                                }
                                                disabled={
                                                  !row.isConformToGeneratePayroll
                                                }
                                              >
                                                <EditSharpIcon
                                                  className={
                                                    classes.editListIcon
                                                  }
                                                />
                                              </Button>
                                            </Grid>
                                          </Tooltip>
                                        </Grid>
                                      </TableCell>
                                    )}
                                  </TableRow>
                                )
                              )
                            )}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </div>
                  </Grid>
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <Grid container spacing={2}>
                      <Grid item lg={6} md={6}></Grid>

                      <Grid
                        item
                        lg={6}
                        md={12}
                        sm={12}
                        xs={12}
                        className={classes.cardGreenBAckGroundColor}
                      >
                        <Grid container spacing={2}>
                          <Grid item lg={12} md={12} sm={12} xs={12}>
                            <Grid container spacing={2}>
                              <Grid
                                item
                                lg={8}
                                md={8}
                                sm={8}
                                xs={8}
                                sx={{
                                  display: "flex",
                                  justifyContent: "flex-start",
                                  alignItems: "center",
                                }}
                              >
                                <Typography
                                  className={classes.cardGreenTypograpy}
                                >
                                  Total Normal Hours :
                                </Typography>
                              </Grid>

                              <Grid
                                item
                                lg={4}
                                md={4}
                                sm={4}
                                xs={4}
                                sx={{
                                  display: "flex",
                                  justifyContent: "flex-end",
                                  alignItems: "center",
                                }}
                                paddingRight={2}
                              >
                                <Typography
                                  className={classes.cardGreenTypograpy}
                                >
                                  {Number(
                                    fieldSums.total_normal_hours || 0
                                  ).toFixed(2)}
                                  {" hrs"}
                                </Typography>
                              </Grid>
                            </Grid>
                          </Grid>
                          <Grid item lg={12} md={12} sm={12} xs={12}>
                            <Grid container spacing={2}>
                              <Grid
                                item
                                lg={8}
                                md={8}
                                sm={8}
                                xs={8}
                                sx={{
                                  display: "flex",
                                  justifyContent: "flex-start",
                                  alignItems: "center",
                                }}
                              >
                                <Typography
                                  className={classes.cardGreenTypograpy}
                                >
                                  Total OT Hours :
                                </Typography>
                              </Grid>

                              <Grid
                                item
                                lg={4}
                                md={4}
                                sm={4}
                                xs={4}
                                sx={{
                                  display: "flex",
                                  justifyContent: "flex-end",
                                  alignItems: "center",
                                }}
                                paddingRight={2}
                                pb={2}
                                borderBottom={0.5}
                              >
                                <Typography
                                  className={classes.cardGreenTypograpy}
                                >
                                  {Number(
                                    fieldSums.total_ot_hours || 0
                                  ).toFixed(2)}
                                  {" hrs"}
                                </Typography>
                              </Grid>
                            </Grid>
                          </Grid>
                          <Grid item lg={12} md={12} sm={12} xs={12} py={1}>
                            <Grid container spacing={2}>
                              <Grid
                                item
                                lg={8}
                                md={8}
                                sm={8}
                                xs={8}
                                sx={{
                                  display: "flex",
                                  justifyContent: "flex-start",
                                  alignItems: "center",
                                }}
                              >
                                <Typography className={classes.h4}>
                                  Total Hours :
                                </Typography>
                              </Grid>

                              <Grid
                                item
                                lg={4}
                                md={4}
                                sm={4}
                                xs={4}
                                sx={{
                                  display: "flex",
                                  justifyContent: "flex-end",
                                  alignItems: "center",
                                }}
                                paddingRight={2}
                              >
                                <Typography className={classes.h4}>
                                  {Number(fieldSums.total_hours || 0).toFixed(
                                    2
                                  )}
                                  {" hrs"}
                                </Typography>
                              </Grid>
                            </Grid>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <Grid container spacing={2}>
                      <Grid item lg={6} md={6}></Grid>

                      <Grid
                        item
                        lg={6}
                        md={12}
                        sm={12}
                        xs={12}
                        className={classes.cardGreenBAckGroundColor}
                      >
                        <Grid container spacing={2}>
                          <Grid item lg={12} md={12} sm={12} xs={12}>
                            <Grid container spacing={2}>
                              <Grid
                                item
                                lg={8}
                                md={8}
                                sm={8}
                                xs={8}
                                sx={{
                                  display: "flex",
                                  justifyContent: "flex-start",
                                  alignItems: "center",
                                }}
                              >
                                <Typography
                                  className={classes.cardGreenTypograpy}
                                >
                                  Total Normal Working Salary :
                                </Typography>
                              </Grid>

                              <Grid
                                item
                                lg={4}
                                md={4}
                                sm={4}
                                xs={4}
                                sx={{
                                  display: "flex",
                                  justifyContent: "flex-end",
                                  alignItems: "center",
                                }}
                                paddingRight={2}
                              >
                                <Typography
                                  className={classes.cardGreenTypograpy}
                                >
                                  {"$ "}
                                  {Number(fieldSums.gross_salary).toFixed(2)}
                                </Typography>
                              </Grid>
                            </Grid>
                          </Grid>
                          <Grid item lg={12} md={12} sm={12} xs={12}>
                            <Grid container spacing={2}>
                              <Grid
                                item
                                lg={8}
                                md={8}
                                sm={8}
                                xs={8}
                                sx={{
                                  display: "flex",
                                  justifyContent: "flex-start",
                                  alignItems: "center",
                                }}
                              >
                                <Typography
                                  className={classes.cardGreenTypograpy}
                                >
                                  Total OT Salary :
                                </Typography>
                              </Grid>

                              <Grid
                                item
                                lg={4}
                                md={4}
                                sm={4}
                                xs={4}
                                sx={{
                                  display: "flex",
                                  justifyContent: "flex-end",
                                  alignItems: "center",
                                }}
                                paddingRight={2}
                              >
                                <Typography
                                  className={classes.cardGreenTypograpy}
                                >
                                  {"$ "}
                                  {Number(fieldSums.ot_salary || 0).toFixed(2)}
                                </Typography>
                              </Grid>
                            </Grid>
                          </Grid>
                          <Grid item lg={12} md={12} sm={12} xs={12}>
                            <Grid container spacing={2}>
                              <Grid
                                item
                                lg={8}
                                md={8}
                                sm={8}
                                xs={8}
                                sx={{
                                  display: "flex",
                                  justifyContent: "flex-start",
                                  alignItems: "center",
                                }}
                              >
                                <Typography
                                  className={classes.cardGreenTypograpy}
                                >
                                  Total Adjustment Amount :
                                </Typography>
                              </Grid>

                              <Grid
                                item
                                lg={4}
                                md={4}
                                sm={4}
                                xs={4}
                                sx={{
                                  display: "flex",
                                  justifyContent: "flex-end",
                                  alignItems: "center",
                                }}
                                paddingRight={2}
                                pb={1}
                                borderBottom={0.5}
                              >
                                <Typography
                                  className={classes.cardGreenTypograpy}
                                >
                                  {"$ "}
                                  {Number(fieldSums.bonus_amount || 0).toFixed(
                                    2
                                  )}
                                </Typography>
                              </Grid>
                            </Grid>
                          </Grid>
                          <Grid item lg={12} md={12} sm={12} xs={12} py={2}>
                            <Grid container spacing={2}>
                              <Grid
                                item
                                lg={8}
                                md={8}
                                sm={8}
                                xs={8}
                                sx={{
                                  display: "flex",
                                  justifyContent: "flex-start",
                                  alignItems: "center",
                                }}
                              >
                                <Typography className={classes.h4}>
                                  Total Amount
                                </Typography>
                              </Grid>

                              <Grid
                                item
                                lg={4}
                                md={4}
                                sm={4}
                                xs={4}
                                sx={{
                                  display: "flex",
                                  justifyContent: "flex-end",
                                  alignItems: "center",
                                }}
                                paddingRight={2}
                              >
                                <Typography className={classes.h4}>
                                  {"$ "}
                                  {Number(fieldSums.total_salary || 0).toFixed(
                                    2
                                  )}
                                </Typography>
                              </Grid>
                            </Grid>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item lg={12} md={12} sm={12} xs={12} pt={3}>
                    <Grid container alignItems="center">
                      <Grid item lg={12} md={12} sm={12} xs={12}>
                        <Typography variant="subtitle1">Description</Typography>
                      </Grid>
                      <Grid item lg={12} md={12} sm={12} xs={12}>
                        <TextField
                          placeholder="Enter Description .."
                          size="small"
                          multiline
                          rows={8}
                          {...formik.getFieldProps("description")}
                          className={classes.discriptionTextField}
                          InputProps={{
                            sx: {
                              fontSize: 14,
                            },
                          }}
                          InputLabelProps={{
                            sx: {
                              fontSize: 14,
                            },
                          }}
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>

              <Grid
                item
                lg={12}
                md={12}
                sm={12}
                xs={12}
                sx={{ paddingBottom: 5 }}
                className={classes.titleGrid}
              >
                <Grid
                  container
                  style={{
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  {userHasRight(Privileges.GeneratePayroll) && (
                    <Grid
                      item
                      lg={12}
                      md={12}
                      sm={12}
                      xs={12}
                      sx={{
                        display: "flex",
                        justifyContent: "flex-end",
                      }}
                    >
                      <Button
                        variant="contained"
                        startIcon={<CheckCircleOutlineIcon />}
                        className={classes.addButton}
                        disabled={
                          !payrollList.some(
                            (row) => row.isConformToGeneratePayroll
                          ) || coursings.length === 0
                        }
                        onClick={handleGeneratePayrollAdminConform}
                      >
                        Confirm
                      </Button>
                    </Grid>
                  )}
                </Grid>
              </Grid>
            </>
          ) : (
            <Grid
              item
              lg={12}
              md={12}
              sm={12}
              xs={12}
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                minHeight: "200px",
              }}
            >
              <Grid container spacing={2}>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <Typography className={classes.bodyDialog}>
                    Select date range
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
          )}
        </Grid>
      </Card>

      <Dialog
        open={openDialog}
        onClose={() => setOpenDialog(false)}
        sx={{ padding: 5, minWidth: 450 }}
      >
        <Grid className={isMobileRes ? classes.DialogMobile :classes.Dialog}>
          <Grid
            container
            justifyContent={"space-between"}
            spacing={5}
            sx={{ borderBottom: 2, padding: 2 }}
            className={classes.titleGrid}
          >
            <Grid
              item
              lg={12}
              md={12}
              sm={12}
              xs={12}
              pt={2}
              alignContent={"center"}
            >
              <Typography className={classes.cardTitle}>
                Generate Payroll for selected dates
              </Typography>
            </Grid>
          </Grid>
          <DialogContent>
            <DialogContentText sx={{ pt: 3 }}>
              <Typography className={classes.bodyDialog} pb={2}>
                Are you sure you want to generate payroll for the selected
                dates?
              </Typography>
              <Typography textAlign={"center"} className={classes.body2}>
                <strong>Start Date :</strong>
                {"  "}
                {selectedStartDate?.format("MMM-DD, YYYY") || " "}
              </Typography>
              <Typography textAlign={"center"} className={classes.body2}>
                <strong>End Date :</strong>
                {"  "}
                {selectedEndDate?.format("MMM-DD, YYYY") || " "}
              </Typography>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              variant="outlined"
              startIcon={<CloseIcon />}
              className={classes.addButton}
              onClick={() => handleDialogClose(false)}
            >
              Cancel
            </Button>
            <Box m={0.5}></Box>

            <Button
              onClick={() => handleDialogConfirm(true)}
              variant="contained"
              className={classes.addButton}
            >
              Confirm
            </Button>
          </DialogActions>
        </Grid>
      </Dialog>

      <Dialog
        open={isEditDialogOpen}
        onClose={handleEditClose}
        aria-describedby="alert-dialog-description"
        classes={{ paper: "inherit" }}
        fullScreen={isMobileRes}
        fullWidth={isMobileRes}
        maxWidth="lg"
      >
        <Grid className={isMobileRes ? classes.DialogMobile : classes.Dialog}>
          <Grid container spacing={3}>
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <Card className={classes.stepperCard}>
                <Grid
                  container
                  justifyContent={"space-between"}
                  spacing={5}
                  sx={{ borderBottom: 2, padding: 2 }}
                  className={classes.titleGrid}
                >
                  <Grid item pt={2} alignContent={"center"}>
                    <Typography className={classes.cardTitle}>
                      Edit Payroll Details
                    </Typography>
                  </Grid>
                  <Grid
                    item
                    pt={2}
                    sx={{ display: "flex", justifyContent: "flex-end" }}
                  >
                    <Button
                      variant="contained"
                      className={classes.editButton}
                      onClick={handleEditClose}
                    >
                      <CloseIcon />
                    </Button>
                  </Grid>
                </Grid>
              </Card>
            </Grid>
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <Grid container spacing={3}>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <Card className={classes.card}>
                    <Grid
                      container
                      justifyContent={"space-between"}
                      spacing={5}
                      sx={{ borderBottom: 2, padding: 2 }}
                      className={classes.titleGrid}
                    >
                      <Grid
                        item
                        lg={12}
                        md={12}
                        sm={12}
                        xs={12}
                        pt={2}
                        alignContent={"center"}
                      >
                        <Typography className={classes.cardTitle}>
                          Edit ({editData?.employee_name || ""})
                        </Typography>
                      </Grid>
                    </Grid>

                    <Grid container spacing={3} p={"24px"}>
                      <Grid item lg={3} md={6} sm={12} xs={12}>
                        <Grid container alignItems="center">
                          <Grid item lg={12} md={12} sm={12} xs={12}>
                            <Typography variant="subtitle1">
                              Normal Working Hours
                            </Typography>
                          </Grid>
                          <Grid item lg={12} md={12} sm={12} xs={12}>
                            <TextField
                              placeholder="Normal Working Hours"
                              size="small"
                              value={editData?.total_normal_hours || ""}
                              onChange={(e) =>
                                handleEditChange(
                                  "total_normal_hours",
                                  parseFloat(e.target.value)
                                )
                              }
                              type="number"
                              className={classes.textField}
                              InputProps={{
                                readOnly: true,
                                sx: {
                                  fontSize: 14,
                                  border: "none",
                                },
                                classes: {
                                  root: classes.textFieldQuote,
                                  notchedOutline: classes.notchedOutline,
                                },
                              }}
                              InputLabelProps={{
                                sx: {
                                  fontSize: 14,
                                  border: "none",
                                },
                              }}
                            />
                          </Grid>
                        </Grid>
                      </Grid>
                      <Grid item lg={3} md={6} sm={12} xs={12}>
                        <Grid container alignItems="center">
                          <Grid item lg={12} md={12} sm={12} xs={12}>
                            <Typography variant="subtitle1">
                              Wrk Hourly Salary
                            </Typography>
                          </Grid>
                          <Grid item lg={12} md={12} sm={12} xs={12}>
                            <TextField
                              placeholder="Wrk Hourly Salary"
                              size="small"
                              value={editData?.hourly_salary || ""}
                              onChange={(e) =>
                                handleEditChange(
                                  "hourly_salary",
                                  parseFloat(e.target.value)
                                )
                              }
                              type="number"
                              className={classes.textField}
                              InputProps={{
                                sx: {
                                  fontSize: 14,
                                  border: "none",
                                },
                                classes: {
                                  root: classes.textFieldQuote,
                                  notchedOutline: classes.notchedOutline,
                                },
                              }}
                              InputLabelProps={{
                                sx: {
                                  fontSize: 14,
                                  border: "none",
                                },
                              }}
                            />
                          </Grid>
                        </Grid>
                      </Grid>
                      <Grid item lg={3} md={6} sm={12} xs={12}>
                        <Grid container alignItems="center">
                          <Grid item lg={12} md={12} sm={12} xs={12}>
                            <Typography variant="subtitle1">
                              OT Hours
                            </Typography>
                          </Grid>
                          <Grid item lg={12} md={12} sm={12} xs={12}>
                            <TextField
                              placeholder="OT Hours"
                              size="small"
                              value={editData?.total_ot_hours || ""}
                              onChange={(e) =>
                                handleEditChange(
                                  "total_ot_hours",
                                  parseFloat(e.target.value)
                                )
                              }
                              type="number"
                              className={classes.textField}
                              InputProps={{
                                readOnly: true,
                                sx: {
                                  fontSize: 14,
                                  border: "none",
                                },
                                classes: {
                                  root: classes.textFieldQuote,
                                  notchedOutline: classes.notchedOutline,
                                },
                              }}
                              InputLabelProps={{
                                sx: {
                                  fontSize: 14,
                                  border: "none",
                                },
                              }}
                            />
                          </Grid>
                        </Grid>
                      </Grid>
                      <Grid item lg={3} md={6} sm={12} xs={12}>
                        <Grid container alignItems="center">
                          <Grid item lg={12} md={12} sm={12} xs={12}>
                            <Typography variant="subtitle1">
                              OT Hourly Salary
                            </Typography>
                          </Grid>
                          <Grid item lg={12} md={12} sm={12} xs={12}>
                            <TextField
                              placeholder="OT Hourly Salary"
                              size="small"
                              value={editData?.ot_hourly_salary || ""}
                              onChange={(e) =>
                                handleEditChange(
                                  "ot_hourly_salary",
                                  parseFloat(e.target.value)
                                )
                              }
                              type="number"
                              className={classes.textField}
                              InputProps={{
                                sx: {
                                  fontSize: 14,
                                  border: "none",
                                },
                                classes: {
                                  root: classes.textFieldQuote,
                                  notchedOutline: classes.notchedOutline,
                                },
                              }}
                              InputLabelProps={{
                                sx: {
                                  fontSize: 14,
                                  border: "none",
                                },
                              }}
                            />
                          </Grid>
                        </Grid>
                      </Grid>
                      {/* <Grid item lg={6} md={6} sm={12} xs={12}>
                        <Grid container alignItems="center">
                          <Grid item lg={12} md={12} sm={12} xs={12}>
                            <Typography variant="subtitle1">
                              Bonus Amount
                            </Typography>
                          </Grid>
                          <Grid item lg={12} md={12} sm={12} xs={12}>
                            <TextField
                              placeholder="Bonus Amount"
                              size="small"
                              value={editData?.bonus_amount || ""}
                              onChange={(e) =>
                                handleEditChange(
                                  "bonus_amount",
                                  parseFloat(e.target.value)
                                )
                              }
                              type="number"
                              className={classes.textField}
                              InputProps={{
                                sx: {
                                  fontSize: 14,
                                },
                              }}
                              InputLabelProps={{
                                sx: {
                                  fontSize: 14,
                                },
                              }}
                            />
                          </Grid>
                        </Grid>
                      </Grid> */}
                      <Grid item lg={12} md={12} sm={12} xs={12}>
                        <Grid
                          container
                          direction="row"
                          alignItems="center"
                          spacing={2}
                          paddingTop={5}
                        >
                          <Grid item lg={12} md={12} sm={12} xs={12}>
                            <TableContainer>
                              <Table className={classes.table}>
                                <TableHead className={classes.tableHeaderRow}>
                                  <TableRow>
                                    <TableCell
                                      className={classes.tablheaderPayroll}
                                      sx={{ width: "50%" }}
                                    >
                                      <strong>Remark</strong>
                                    </TableCell>
                                    <TableCell
                                      className={classes.tablheaderPayroll}
                                      sx={{ width: "20%" }}
                                    >
                                      <strong>Action</strong>
                                    </TableCell>
                                    <TableCell
                                      className={classes.tablheaderPayroll}
                                      sx={{ width: "25%" }}
                                    >
                                      <strong>Amount</strong>
                                    </TableCell>
                                    <TableCell
                                      className={classes.tablheaderPayroll}
                                      sx={{ width: "5%" }}
                                    >
                                      <strong></strong>
                                    </TableCell>
                                  </TableRow>
                                </TableHead>
                                <TableBody>
                                  {editData?.bonus_adjustments.map(
                                    (adjustment, index) => (
                                      <TableRow
                                        key={index}
                                        className={classes.tableRowHover}
                                      >
                                        <TableCell
                                          scope="row"
                                          sx={{ width: "50%" }}
                                        >
                                          <TextField
                                            placeholder="Remark"
                                            size="small"
                                            value={adjustment.remark}
                                            onChange={(e) =>
                                              handleAdjustmentChange(
                                                index,
                                                "remark",
                                                e.target.value
                                              )
                                            }
                                            className={classes.textField}
                                            InputProps={{
                                              sx: {
                                                fontSize: 14,
                                                border: "none",
                                              },
                                              classes: {
                                                root: classes.textFieldQuoteNoBorder,
                                                notchedOutline:
                                                  classes.notchedOutline,
                                              },
                                            }}
                                            InputLabelProps={{
                                              sx: {
                                                fontSize: 14,
                                                border: "none",
                                              },
                                            }}
                                          />
                                        </TableCell>
                                        <TableCell
                                          scope="row"
                                          sx={{ width: "20%" }}
                                        >
                                          <TextField
                                            select
                                            size="small"
                                            fullWidth
                                            className={classes.textField}
                                            InputProps={{
                                              sx: {
                                                fontSize: 14,
                                                border: "none",
                                              },
                                              classes: {
                                                root: classes.textFieldQuoteNoBorder,
                                                notchedOutline:
                                                  classes.notchedOutline,
                                              },
                                            }}
                                            InputLabelProps={{
                                              shrink: true,
                                              sx: {
                                                fontSize: 14,
                                                border: "none",
                                              },
                                            }}
                                            value={adjustment.selector}
                                            onChange={(e) =>
                                              handleAdjustmentChange(
                                                index,
                                                "selector",
                                                e.target.value
                                              )
                                            }
                                          >
                                            <MenuItem value="add">Add</MenuItem>
                                            <MenuItem value="remove">
                                              Remove
                                            </MenuItem>
                                          </TextField>
                                        </TableCell>
                                        <TableCell
                                          scope="row"
                                          sx={{ width: "25%" }}
                                        >
                                          <TextField
                                            placeholder="Amount"
                                            size="small"
                                            value={adjustment.value}
                                            onChange={(e) =>
                                              handleAdjustmentChange(
                                                index,
                                                "value",
                                                parseFloat(e.target.value)
                                              )
                                            }
                                            type="number"
                                            className={classes.textField}
                                            InputProps={{
                                              sx: {
                                                fontSize: 14,
                                                border: "none",
                                              },
                                              classes: {
                                                root: classes.textFieldQuoteNoBorder,
                                                notchedOutline:
                                                  classes.notchedOutline,
                                              },
                                            }}
                                            InputLabelProps={{
                                              sx: {
                                                fontSize: 14,
                                                border: "none",
                                              },
                                            }}
                                          />
                                        </TableCell>
                                        <TableCell
                                          scope="row"
                                          sx={{ width: "5%" }}
                                        >
                                          <Grid
                                            container
                                            spacing={1}
                                            sx={{
                                              display: "flex",
                                              justifyContent: "flex-end",
                                            }}
                                          >
                                            <Grid item>
                                              <IconButton
                                                color="error"
                                                onClick={() =>
                                                  removeAdjustment(index)
                                                }
                                              >
                                                <FaTrash />
                                              </IconButton>
                                            </Grid>
                                          </Grid>
                                        </TableCell>
                                      </TableRow>
                                    )
                                  )}
                                </TableBody>
                              </Table>
                            </TableContainer>
                          </Grid>

                          <Grid
                            item
                            lg={12}
                            md={12}
                            sm={12}
                            xs={12}
                            py={2}
                            sx={{
                              display: "flex",
                              justifyContent: "flex-end",
                            }}
                          >
                            <Button
                              variant="contained"
                              startIcon={<AddIcon />}
                              className={classes.addButton}
                              onClick={addAdjustment}
                            >
                              Add
                            </Button>
                          </Grid>
                        </Grid>
                      </Grid>

                      <Grid item lg={12} md={12} sm={12} xs={12}>
                        <Grid container spacing={2}>
                          <Grid item lg={6} md={6}></Grid>

                          <Grid
                            item
                            lg={6}
                            md={6}
                            sm={12}
                            xs={12}
                            className={classes.cardGreenBAckGroundColor}
                          >
                            <Grid container spacing={2}>
                              <Grid item lg={12} md={12} sm={12} xs={12}>
                                <Grid container spacing={2}>
                                  <Grid
                                    item
                                    lg={8}
                                    md={8}
                                    sm={8}
                                    xs={8}
                                    sx={{
                                      display: "flex",
                                      justifyContent: "flex-start",
                                      alignItems: "center",
                                    }}
                                  >
                                    <Typography
                                      className={classes.cardGreenTypograpy}
                                    >
                                      Normal Working Amount (
                                      {Number(
                                        editData?.total_normal_hours || 0
                                      ).toFixed(2)}
                                      {" hrs * $"}
                                      {Number(
                                        editData?.hourly_salary || 0
                                      ).toFixed(2)}
                                      )
                                    </Typography>
                                  </Grid>

                                  <Grid
                                    item
                                    lg={4}
                                    md={4}
                                    sm={4}
                                    xs={4}
                                    sx={{
                                      display: "flex",
                                      justifyContent: "flex-end",
                                      alignItems: "center",
                                    }}
                                    paddingRight={2}
                                  >
                                    <Typography
                                      className={classes.cardGreenTypograpy}
                                    >
                                      {"$ "}
                                      {Number(
                                        Number(
                                          editData?.total_normal_hours || 0
                                        ) * Number(editData?.hourly_salary || 0)
                                      ).toFixed(2)}
                                    </Typography>
                                  </Grid>
                                </Grid>
                              </Grid>
                              <Grid item lg={12} md={12} sm={12} xs={12}>
                                <Grid container spacing={2}>
                                  <Grid
                                    item
                                    lg={8}
                                    md={8}
                                    sm={8}
                                    xs={8}
                                    sx={{
                                      display: "flex",
                                      justifyContent: "flex-start",
                                      alignItems: "center",
                                    }}
                                  >
                                    <Typography
                                      className={classes.cardGreenTypograpy}
                                    >
                                      OT Amount (
                                      {Number(
                                        editData?.total_ot_hours || 0
                                      ).toFixed(2)}
                                      {" hrs * $"}
                                      {Number(
                                        editData?.ot_hourly_salary || 0
                                      ).toFixed(2)}
                                      )
                                    </Typography>
                                  </Grid>

                                  <Grid
                                    item
                                    lg={4}
                                    md={4}
                                    sm={4}
                                    xs={4}
                                    sx={{
                                      display: "flex",
                                      justifyContent: "flex-end",
                                      alignItems: "center",
                                    }}
                                    paddingRight={2}
                                  >
                                    <Typography
                                      className={classes.cardGreenTypograpy}
                                    >
                                      {"$ "}
                                      {Number(
                                        Number(editData?.total_ot_hours || 0) *
                                          Number(
                                            editData?.ot_hourly_salary || 0
                                          )
                                      ).toFixed(2)}
                                    </Typography>
                                  </Grid>
                                </Grid>
                              </Grid>
                              <Grid item lg={12} md={12} sm={12} xs={12}>
                                <Grid container spacing={2}>
                                  <Grid
                                    item
                                    lg={8}
                                    md={8}
                                    sm={8}
                                    xs={8}
                                    sx={{
                                      display: "flex",
                                      justifyContent: "flex-start",
                                      alignItems: "center",
                                    }}
                                  >
                                    <Typography
                                      className={classes.cardGreenTypograpy}
                                    >
                                      Adjustment Amount
                                    </Typography>
                                  </Grid>

                                  <Grid
                                    item
                                    lg={4}
                                    md={4}
                                    sm={4}
                                    xs={4}
                                    sx={{
                                      display: "flex",
                                      justifyContent: "flex-end",
                                      alignItems: "center",
                                    }}
                                    paddingRight={2}
                                    pb={1}
                                    borderBottom={0.5}
                                  >
                                    <Typography
                                      className={classes.cardGreenTypograpy}
                                    >
                                      {"$ "}
                                      {Number(
                                        editData?.bonus_amount || 0
                                      ).toFixed(2)}
                                    </Typography>
                                  </Grid>
                                </Grid>
                              </Grid>
                              <Grid item lg={12} md={12} sm={12} xs={12} py={2}>
                                <Grid container spacing={2}>
                                  <Grid
                                    item
                                    lg={8}
                                    md={8}
                                    sm={8}
                                    xs={8}
                                    sx={{
                                      display: "flex",
                                      justifyContent: "flex-start",
                                      alignItems: "center",
                                    }}
                                  >
                                    <Typography className={classes.h4}>
                                      Total Amount
                                    </Typography>
                                  </Grid>

                                  <Grid
                                    item
                                    lg={4}
                                    md={4}
                                    sm={4}
                                    xs={4}
                                    sx={{
                                      display: "flex",
                                      justifyContent: "flex-end",
                                      alignItems: "center",
                                    }}
                                    paddingRight={2}
                                  >
                                    <Typography className={classes.h4}>
                                      {"$ "}
                                      {Number(
                                        editData?.total_salary || 0
                                      ).toFixed(2)}
                                    </Typography>
                                  </Grid>
                                </Grid>
                              </Grid>
                            </Grid>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Card>
                </Grid>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <Card className={classes.card}>
                    <Grid
                      container
                      justifyContent={"space-between"}
                      spacing={5}
                      sx={{ borderBottom: 2, padding: 2 }}
                      className={classes.titleGrid}
                    >
                      <Grid
                        item
                        lg={12}
                        md={12}
                        sm={12}
                        xs={12}
                        pt={2}
                        alignContent={"center"}
                      >
                        <Typography className={classes.cardTitle}>
                          Remark
                        </Typography>
                      </Grid>
                    </Grid>

                    <Grid container spacing={3} p={"24px"}>
                      <Grid item lg={12} md={12} sm={12} xs={12}>
                        <Grid container alignItems="center">
                          <Grid item lg={12} md={12} sm={12} xs={12}>
                            <TextField
                              placeholder="Remark"
                              size="small"
                              value={editData?.edited_reason || ""}
                              multiline
                              rows={8}
                              onChange={(e) =>
                                handleEditChange(
                                  "edited_reason",
                                  e.target.value
                                )
                              }
                              className={classes.discriptionTextField}
                              InputProps={{
                                sx: {
                                  fontSize: 14,
                                },
                              }}
                              InputLabelProps={{
                                sx: {
                                  fontSize: 14,
                                },
                              }}
                            />
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Card>
                </Grid>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <Card className={classes.card}>
                    <Grid container spacing={3} p={"24px"}>
                      <Grid
                        item
                        lg={12}
                        md={12}
                        sm={12}
                        xs={12}
                        sx={{ display: "flex", justifyContent: "flex-end" }}
                      >
                        <Button
                          variant="outlined"
                          startIcon={<CloseIcon />}
                          className={classes.addButton}
                          onClick={handleEditClose}
                        >
                          Cancel
                        </Button>
                        <Box m={0.5}></Box>

                        <Button
                          variant="contained"
                          startIcon={<CheckCircleOutlineIcon/>}
                          className={classes.addButton}
                          onClick={handleEditSave}
                        >
                          Submit
                        </Button>
                      </Grid>
                    </Grid>
                  </Card>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Dialog>

      <Dialog
        open={open}
        onClose={handleClose}
        aria-describedby="alert-dialog-description"
        classes={{ paper: "inherit" }}
        fullScreen={isMobileRes}
        fullWidth={isMobileRes}
        maxWidth="lg"
      >
        <Grid className={isMobileRes ? classes.DialogMobile : classes.Dialog}>
          <Grid container spacing={3}>
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <Grid container spacing={3}>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <Card className={classes.card}>
                    <Grid
                      container
                      justifyContent={"space-between"}
                      spacing={5}
                      sx={{ borderBottom: 2, padding: 2 }}
                      className={classes.titleGrid}
                    >
                      <Grid item pt={2} alignContent={"center"}>
                        <Typography className={classes.cardTitle}>
                          Employee Payroll Details
                        </Typography>
                      </Grid>
                      <Grid
                        item
                        pt={2}
                        sx={{ display: "flex", justifyContent: "flex-end" }}
                      >
                        <Button
                          variant="contained"
                          className={classes.editButton}
                          onClick={handleClose}
                        >
                          <CloseIcon />
                        </Button>
                      </Grid>
                    </Grid>
                  </Card>
                </Grid>

                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <Card className={classes.card}>
                    <Grid
                      container
                      justifyContent={"space-between"}
                      spacing={5}
                      sx={{ borderBottom: 2, padding: 2 }}
                      className={classes.titleGrid}
                    >
                      <Grid
                        item
                        lg={6}
                        md={6}
                        sm={12}
                        xs={12}
                        pt={2}
                        alignContent={"center"}
                      >
                        <Typography className={classes.cardTitle}>
                          {selectedName}
                        </Typography>
                      </Grid>
                      <Grid
                        item
                        lg={6}
                        md={6}
                        sm={8}
                        xs={8}
                        sx={{ display: "flex", justifyContent: "flex-end" }}
                      >
                        <Grid
                          container
                          spacing={1}
                          justifyContent="flex-end"
                          sx={{ display: "flex" }}
                        >
                          <Grid item>
                            <Button
                              startIcon={<LocalPrintshopSharpIcon />}
                              className={classes.addButtonPdfExcel}
                              onClick={handleEmployeePunchExcel}
                            >
                              Excel
                            </Button>
                          </Grid>
                          <Grid item>
                            <Button
                              startIcon={<LocalPrintshopSharpIcon />}
                              className={classes.addButtonPdfExcel}
                              onClick={handleExportToPDFForEmployeePunch}
                            >
                              pdf
                            </Button>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>

                    <Grid container spacing={3}>
                      <Grid item lg={12} md={12} sm={12} xs={12}>
                        <TableContainer>
                          <Table className={classes.table}>
                            <TableHead className={classes.tableHeaderRow}>
                              <TableRow>
                                <TableCell
                                  className={classes.tablheaderPayroll}
                                >
                                  <strong>Date</strong>
                                </TableCell>
                                <TableCell
                                  className={classes.tablheaderPayroll}
                                  sx={{ textAlign: "left" }}
                                >
                                  <strong>Records</strong>
                                </TableCell>
                                <TableCell
                                  className={classes.tablheaderPayroll}
                                  sx={{ textAlign: "right" }}
                                >
                                  <strong>Actual Hours</strong>
                                </TableCell>
                                <TableCell
                                  className={classes.tablheaderPayroll}
                                  sx={{ textAlign: "right" }}
                                >
                                  <strong>Total Break Hours</strong>
                                </TableCell>

                                <TableCell
                                  className={classes.tablheaderPayroll}
                                  sx={{ textAlign: "right" }}
                                >
                                  <strong>Total working hours</strong>
                                </TableCell>
                                <TableCell
                                  className={classes.tablheaderPayroll}
                                  sx={{ textAlign: "right" }}
                                >
                                  <strong>Hourly Salary</strong>
                                </TableCell>
                                <TableCell
                                  className={classes.tablheaderPayroll}
                                  sx={{ textAlign: "right" }}
                                >
                                  <strong>Total Amount</strong>
                                </TableCell>
                                {/* <TableCell
                                  className={classes.tablheaderPayroll}
                                  sx={{ textAlign: "right" }}
                                >
                                  <strong>Actions</strong>
                                </TableCell> */}
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {payRollAnEmployeeLoading || positionLoading ? (
                                <TableRow>
                                  <TableCell colSpan={20} align="center">
                                    <Box
                                      display="flex"
                                      justifyContent="center"
                                      alignItems="center"
                                      height="10vh"
                                    >
                                      <CircularProgress />
                                    </Box>
                                  </TableCell>
                                </TableRow>
                              ) : payRollAnEmployeeIsError ||
                                EmployeePunchRecord.length === 0 ? (
                                <TableRow>
                                  <TableCell colSpan={20} align="center">
                                    {isError
                                      ? "Error fetching data"
                                      : "No data available"}
                                  </TableCell>
                                </TableRow>
                              ) : (
                                EmployeePunchRecord.map(
                                  (row: IEmployeePunchRecord, index) => (
                                    <TableRow
                                      key={row.id}
                                      className={classes.tableRowHover}
                                    >
                                      <TableCell
                                        scope="row"
                                        className={classes.tablCellPayroll}
                                      >
                                        {dayjs(row.recordDate).format(
                                          "YYYY-MM-DD"
                                        )}
                                      </TableCell>
                                      <TableCell
                                        scope="row"
                                        className={classes.tablCellPayroll}
                                        sx={{ textAlign: "left" }}
                                      >
                                        {row.punchDetails.length > 0 ? (
                                          row.punchDetails.map(
                                            (punchDetail, index) => (
                                              <span key={index}>
                                                {formatTime(
                                                  punchDetail.punch_in_time
                                                )}{" "}
                                                -{" "}
                                                {formatTime(
                                                  punchDetail.punch_out_time
                                                )}
                                                {index !==
                                                  row.punchDetails.length - 1 &&
                                                  ", "}
                                              </span>
                                            )
                                          )
                                        ) : (
                                          <span> </span>
                                        )}
                                      </TableCell>
                                      <TableCell
                                        scope="row"
                                        className={classes.tablCellPayroll}
                                        sx={{ textAlign: "right" }}
                                      >
                                        {row.break_hours === null ||
                                        row.total_hours === null ||
                                        isNaN(
                                          parseFloat(String(row.break_hours))
                                        ) ||
                                        isNaN(
                                          parseFloat(String(row.total_hours))
                                        )
                                          ? ""
                                          : parseFloat(
                                              String(row.break_hours)
                                            ) +
                                              parseFloat(
                                                String(row.total_hours)
                                              ) ===
                                            0
                                          ? "-"
                                          : `${(
                                              parseFloat(
                                                String(row.break_hours)
                                              ) +
                                              parseFloat(
                                                String(row.total_hours)
                                              )
                                            ).toFixed(2)} hrs`}
                                      </TableCell>

                                      <TableCell
                                        scope="row"
                                        className={classes.tablCellPayroll}
                                        sx={{ textAlign: "right" }}
                                      >
                                        {row.break_hours === null ||
                                        isNaN(
                                          parseFloat(String(row.break_hours))
                                        )
                                          ? ""
                                          : parseFloat(
                                              String(row.break_hours)
                                            ) === 0
                                          ? "-"
                                          : `${parseFloat(
                                              String(row.break_hours)
                                            ).toFixed(2)} hrs`}
                                      </TableCell>
                                      <TableCell
                                        scope="row"
                                        className={classes.tablCellPayroll}
                                        sx={{ textAlign: "right" }}
                                      >
                                        {row.total_hours === null ||
                                        isNaN(
                                          parseFloat(String(row.total_hours))
                                        )
                                          ? ""
                                          : parseFloat(
                                              String(row.total_hours)
                                            ) === 0
                                          ? "-"
                                          : `${parseFloat(
                                              String(row.total_hours)
                                            ).toFixed(2)} hrs`}
                                      </TableCell>
                                      <TableCell
                                        scope="row"
                                        className={classes.tablCellPayroll}
                                        sx={{ textAlign: "right" }}
                                      >
                                        {selectedHrs === null ||
                                        isNaN(parseFloat(String(selectedHrs)))
                                          ? ""
                                          : parseFloat(String(selectedHrs)) ===
                                            0
                                          ? "-"
                                          : `$ ${parseFloat(
                                              String(selectedHrs)
                                            ).toFixed(2)}`}
                                      </TableCell>
                                      <TableCell
                                        scope="row"
                                        className={classes.tablCellPayroll}
                                        sx={{ textAlign: "right" }}
                                      >
                                        {selectedHrs === null ||
                                        row.total_hours === null ||
                                        isNaN(
                                          parseFloat(String(selectedHrs)) *
                                            row.total_hours
                                        )
                                          ? ""
                                          : parseFloat(String(selectedHrs)) *
                                              row.total_hours ===
                                            0
                                          ? "-"
                                          : `$ ${(
                                              parseFloat(String(selectedHrs)) *
                                              row.total_hours
                                            ).toFixed(2)}`}
                                      </TableCell>
                                      {/* <TableCell className={classes.tablCellPayroll}>
                                      <Grid
                                        container
                                        spacing={1}
                                        sx={{
                                          display: "flex",
                                          justifyContent: "flex-end",
                                        }}
                                      >
                                        <Grid item>
                                          <Button
                                            // variant="contained"
                                            className={classes.editButtonList}
                                            onClick={() =>
                                              handleDateViewClick(
                                                String(row.recordDate)
                                              )
                                            }
                                          >
                                            <VisibilitySharpIcon
                                              className={classes.editListIcon}
                                            />
                                          </Button>
                                        </Grid>
                                      </Grid>
                                    </TableCell> */}
                                    </TableRow>
                                  )
                                )
                              )}

                              <TableRow className={classes.tableRowHover}>
                                <TableCell
                                  scope="row"
                                  className={classes.tablCellPayroll}
                                ></TableCell>
                                <TableCell
                                  scope="row"
                                  className={classes.tablCellPayroll}
                                  sx={{ textAlign: "left" }}
                                ></TableCell>
                                <TableCell
                                  scope="row"
                                  className={classes.tablCellPayroll}
                                  sx={{ textAlign: "right" }}
                                ></TableCell>

                                <TableCell
                                  scope="row"
                                  className={classes.tablCellPayroll}
                                  sx={{ textAlign: "right" }}
                                >
                                  {coursingToDelete &&
                                  coursingToDelete.total_break_hours !== null &&
                                  !isNaN(
                                    parseFloat(
                                      String(coursingToDelete.total_break_hours)
                                    )
                                  )
                                    ? parseFloat(
                                        String(
                                          coursingToDelete.total_break_hours
                                        )
                                      ) === 0
                                      ? "-"
                                      : `${parseFloat(
                                          String(
                                            coursingToDelete.total_break_hours
                                          )
                                        ).toFixed(2)} hrs`
                                    : ""}
                                </TableCell>
                                <TableCell
                                  scope="row"
                                  className={classes.tablCellPayroll}
                                  sx={{ textAlign: "right" }}
                                >
                                  {coursingToDelete &&
                                  coursingToDelete.total_hours !== null &&
                                  !isNaN(
                                    parseFloat(
                                      String(coursingToDelete.total_hours)
                                    )
                                  )
                                    ? parseFloat(
                                        String(coursingToDelete.total_hours)
                                      ) === 0
                                      ? "-"
                                      : `${parseFloat(
                                          String(coursingToDelete.total_hours)
                                        ).toFixed(2)} hrs`
                                    : ""}
                                </TableCell>
                                <TableCell
                                  scope="row"
                                  className={classes.tablCellPayroll}
                                  sx={{ textAlign: "right" }}
                                ></TableCell>
                                <TableCell
                                  scope="row"
                                  className={classes.tablCellPayroll}
                                  sx={{ textAlign: "right" }}
                                >
                                  {coursingToDelete &&
                                  coursingToDelete.gross_salary !== null &&
                                  !isNaN(
                                    parseFloat(
                                      String(coursingToDelete.gross_salary)
                                    )
                                  )
                                    ? parseFloat(
                                        String(coursingToDelete.gross_salary)
                                      ) === 0
                                      ? "-"
                                      : `$ ${parseFloat(
                                          String(coursingToDelete.gross_salary)
                                        ).toFixed(2)}`
                                    : ""}
                                </TableCell>
                              </TableRow>
                            </TableBody>
                          </Table>
                        </TableContainer>
                      </Grid>
                    </Grid>
                  </Card>
                </Grid>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <Card className={classes.card}>
                    <Grid container spacing={3} p={"24px"}>
                      <Grid
                        item
                        lg={12}
                        md={12}
                        sm={12}
                        xs={12}
                        sx={{ display: "flex", justifyContent: "flex-end" }}
                      >
                        <Button
                          variant="outlined"
                          startIcon={<CloseIcon />}
                          className={classes.addButton}
                          onClick={handleClose}
                        >
                          Cancel
                        </Button>
                      </Grid>
                    </Grid>
                  </Card>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Dialog>

      <Dialog
        open={openAdminConfim}
        onClose={() => setOpenAdminConfim(false)}
        sx={{ padding: 5, minWidth: 450 }}
      >
        <Grid className={isMobileRes ? classes.DialogMobile :classes.Dialog}>
          <Grid
            container
            justifyContent={"space-between"}
            spacing={5}
            sx={{ borderBottom: 2, padding: 2 }}
            className={classes.titleGrid}
          >
            <Grid
              item
              lg={12}
              md={12}
              sm={12}
              xs={12}
              pt={2}
              alignContent={"center"}
            >
              <Typography className={classes.cardTitle}>
                Generate Payroll
              </Typography>
            </Grid>
          </Grid>
          <DialogContent>
            <DialogContentText sx={{ pt: 3 }}>
              Are you sure you want to generate payroll?
              {newEmployeeDataIsLoading && (
                <Box
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  height="10vh"
                >
                  <CircularProgress />
                </Box>
              )}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              variant="outlined"
              startIcon={<CloseIcon />}
              className={classes.addButton}
              onClick={() => handleDialogCloseAdminConform(false)}
            >
              Cancel
            </Button>
            <Box m={0.5}></Box>
            {userHasRight(Privileges.GeneratePayroll) && (
              <Button
                onClick={() => handleDialogAdminConform(true)}
                variant="contained"
                startIcon={
                  isLoading ? (
                    <CircularProgress size={18} className={classes.isLoading} />
                  ) : (
                    <CheckCircleOutlineIcon />
                  )
                }
                className={classes.addButton}
              >
                Confirm
              </Button>
            )}
          </DialogActions>
        </Grid>
      </Dialog>

      <Dialog
        open={openAdminConfim2}
        onClose={() => setOpenAdminConfim2(false)}
        sx={{ padding: 5, minWidth: 450 }}
      >
        <Grid className={isMobileRes ? classes.DialogMobile :classes.Dialog}>
          <Grid container spacing={3}>
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <Grid container spacing={3}>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <Card className={classes.card}>
                    <Grid
                      container
                      justifyContent={"space-between"}
                      spacing={5}
                      sx={{ borderBottom: 2, padding: 2 }}
                      className={classes.titleGrid}
                    >
                      <Grid
                        item
                        lg={12}
                        md={12}
                        sm={12}
                        xs={12}
                        pt={2}
                        alignContent={"center"}
                      >
                        <Typography className={classes.cardTitle}>
                          Employee Payroll Date Details
                        </Typography>
                      </Grid>
                    </Grid>

                    <Grid container spacing={3} p={"24px"}>
                      <Grid item lg={12} md={12} sm={12} xs={12}>
                        <TableContainer>
                          <Table className={classes.table}>
                            <TableHead className={classes.tableHeaderRow}>
                              <TableRow>
                                <TableCell
                                  className={classes.tablheaderPayroll}
                                >
                                  <strong>Date</strong>
                                </TableCell>
                                <TableCell
                                  className={classes.tablheaderPayroll}
                                  // sx={{ textAlign: "center" }}
                                >
                                  <strong>Time Range</strong>
                                </TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {payRollEachEmployeeLoading ? (
                                <TableRow>
                                  <TableCell colSpan={20} align="center">
                                    <Box
                                      display="flex"
                                      justifyContent="center"
                                      alignItems="center"
                                      height="10vh"
                                    >
                                      <CircularProgress />
                                    </Box>
                                  </TableCell>
                                </TableRow>
                              ) : payRollEachEmployeeIsError ||
                                EmployeePunchRecord.length === 0 ? (
                                <TableRow>
                                  <TableCell colSpan={20} align="center">
                                    {isError
                                      ? "Error fetching data"
                                      : "No data available"}
                                  </TableCell>
                                </TableRow>
                              ) : (
                                EmpEachPunchRecord.map(
                                  (row: IPayrollEachEmployeDateList, index) => (
                                    <TableRow
                                      key={row.id}
                                      className={classes.tableRowHover}
                                    >
                                      <TableCell
                                        scope="row"
                                        className={classes.tablCellPayroll}
                                      >
                                        {dayjs(row.punch_in_date).format(
                                          "YYYY-MM-DD"
                                        )}
                                      </TableCell>
                                      <TableCell
                                        scope="row"
                                        className={classes.tablCellPayroll}
                                        // sx={{ textAlign: "center" }}
                                      >
                                        {formatTime(row.punch_in_time)} -{" "}
                                        {formatTime(row.punch_out_time)}
                                      </TableCell>
                                    </TableRow>
                                  )
                                )
                              )}
                            </TableBody>
                          </Table>
                        </TableContainer>
                      </Grid>
                    </Grid>
                  </Card>
                </Grid>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <Card className={classes.card}>
                    <Grid container spacing={3} p={"24px"}>
                      <Grid
                        item
                        lg={12}
                        md={12}
                        sm={12}
                        xs={12}
                        sx={{ display: "flex", justifyContent: "flex-end" }}
                      >
                        <Button
                          variant="outlined"
                          startIcon={<CloseIcon />}
                          className={classes.addButton}
                          onClick={() => handleDialogCloseAdminConform2(false)}
                        >
                          Cancel
                        </Button>
                      </Grid>
                    </Grid>
                  </Card>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Dialog>
    </div>
  );
};

export default Index;
